import { ApiLotteryData } from "../../AdminLottery/model/adminLottery.model";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Badge } from "primereact/badge";
import { useState } from "react";

interface Props {
  dataLotteryForUser: ApiLotteryData[];
}

function TableLotteryToUser({ dataLotteryForUser }: Props): JSX.Element {
  const [globalFilter, setGlobalFilter] = useState<string | null>(null);

  const headerSearch = (
    <div className="flex justify-content-end">
      <InputText
        type="text"
        placeholder="Buscar..."
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setGlobalFilter(e.target.value)
        }
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid #cbd5e1",
          color: "#333333",
          borderRadius: "6px",
          padding: "0.5rem 0.75rem",
          width: "220px",
        }}
      />
    </div>
  );

  return (
    <div>
      <style>{`
        /* Header de columnas */
        .lottery-table .p-datatable-thead > tr > th {
          background-color: #f8fafc !important;
          color: #374151 !important;
          border-bottom: 2px solid #e5e7eb !important;
          border-color: #e5e7eb !important;
          font-size: 0.78rem !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          padding: 0.85rem 1rem !important;
        }

        /* Filas */
        .lottery-table .p-datatable-tbody > tr {
          background-color: #ffffff !important;
          color: #374151 !important;
          border-bottom: 1px solid #f1f5f9 !important;
          transition: background 0.15s ease !important;
        }
        .lottery-table .p-datatable-tbody > tr:hover {
          background-color: #f0fdf9 !important;
        }
        .lottery-table .p-datatable-tbody > tr > td {
          border-color: #f1f5f9 !important;
          padding: 0.85rem 1rem !important;
          color: #374151 !important;
          font-size: 0.9rem !important;
        }

        /* Iconos de sort */
        .lottery-table .p-sortable-column-icon {
          color: #9ca3af !important;
        }
        .lottery-table .p-sortable-column:hover {
          background-color: #f1f5f9 !important;
          color: #374151 !important;
        }
        .lottery-table .p-highlight .p-sortable-column-icon {
          color: #00A86B !important;
        }

        /* Header del DataTable (buscador) */
        .lottery-table .p-datatable-header {
          background-color: #ffffff !important;
          border: none !important;
          padding: 0 0 0.75rem 0 !important;
        }

        /* Paginador */
        .lottery-table .p-paginator {
          background-color: #ffffff !important;
          border-top: 1px solid #e5e7eb !important;
        }
        .lottery-table .p-paginator .p-paginator-page.p-highlight {
          background-color: #00A86B !important;
          color: #ffffff !important;
          border-color: #00A86B !important;
        }
        .lottery-table .p-paginator .p-paginator-element {
          color: #374151 !important;
        }

        /* Gridlines */
        .lottery-table .p-datatable-gridlines .p-datatable-tbody > tr > td {
          border-color: #f1f5f9 !important;
        }
        .lottery-table .p-datatable-gridlines .p-datatable-thead > tr > th {
          border-color: #e5e7eb !important;
        }
      `}</style>

      <DataTable
        value={dataLotteryForUser}
        resizableColumns
        showGridlines
        tableStyle={{ minWidth: "50rem" }}
        emptyMessage="No hay resultados"
        globalFilter={globalFilter}
        header={dataLotteryForUser.length > 5 ? headerSearch : null}
        paginator={dataLotteryForUser.length > 5}
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        className="lottery-table"
        style={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #e5e7eb" }}
      >
        <Column field="idLottery" header="ID" sortable style={{ width: "10%" }} />
        <Column field="descriptionLottery" header="Detalle" sortable style={{ width: "35%" }} />
        <Column field="rewardLottery" header="Ganancia estimada" sortable style={{ width: "30%" }} />
        <Column
          field="stateLottery"
          header="Estado del sorteo"
          sortable
          style={{ width: "25%" }}
          body={(rowData: ApiLotteryData) => (
            <Badge
              severity={rowData.stateLottery ? "success" : "danger"}
              value={rowData.stateLottery ? "Activo" : "Inactivo"}
            />
          )}
        />
      </DataTable>
    </div>
  );
}

export default TableLotteryToUser;